import { ButtonGroup } from 'bold-ui'
import { ButtonLink } from 'components/route'
import { useLocation } from 'react-router'
import { matchPath } from 'react-router-dom'
import { PINO_TERRITORIO_MODAL_ROUTE } from 'view/visualizacaoTerritorial/territorio-mapas/model-territorioMapa'

export enum TerritorioViewTabEnum {
  LISTA_DE_IMOVEIS = 'LISTA_DE_IMOVEIS',
  MAPA_DO_TERRITORIO = 'MAPA_DO_TERRITORIO',
}

export const TERRITORIO_TABS_ROUTE: Record<TerritorioViewTabEnum, string> = {
  [TerritorioViewTabEnum.LISTA_DE_IMOVEIS]: 'lista-de-imoveis',
  [TerritorioViewTabEnum.MAPA_DO_TERRITORIO]: 'mapa-do-territorio',
}

interface TerritorioContentSwitchProps {
  baseUrl: string
}

export function TerritorioContentSwitch(props: Readonly<TerritorioContentSwitchProps>) {
  const { baseUrl } = props
  const location = useLocation()

  const listaDeImoveisUrl = `${baseUrl}/${TERRITORIO_TABS_ROUTE[TerritorioViewTabEnum.LISTA_DE_IMOVEIS]}`
  const mapaDoTerritorioUrl = `${baseUrl}/${TERRITORIO_TABS_ROUTE[TerritorioViewTabEnum.MAPA_DO_TERRITORIO]}`

  const isListaDeImoveisActive = !!matchPath(location.pathname, { path: listaDeImoveisUrl, exact: true })
  const isMapaDoTerritorioActive = !!matchPath(location.pathname, {
    path: [
      `${mapaDoTerritorioUrl}/:mapaSidebarNavItem?/${PINO_TERRITORIO_MODAL_ROUTE}/:imovelId(\\d+)`,
      `${mapaDoTerritorioUrl}/:mapaSidebarNavItem?`,
    ],
    exact: true,
  })

  return (
    <ButtonGroup>
      <ButtonLink size='small' kind={isListaDeImoveisActive ? 'primary' : 'normal'} to={listaDeImoveisUrl}>
        Lista de imóveis
      </ButtonLink>
      <ButtonLink size='small' kind={isMapaDoTerritorioActive ? 'primary' : 'normal'} to={mapaDoTerritorioUrl}>
        Mapa do território
      </ButtonLink>
    </ButtonGroup>
  )
}
